import { render, staticRenderFns } from "./AboutCollaborations.vue?vue&type=template&id=6f83b465&"
import script from "./AboutCollaborations.vue?vue&type=script&lang=js&"
export * from "./AboutCollaborations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports